const getters = {
  getFts: (state) => state.fts,
  getItemSelect: (state) => state.itemSelect,
};

export default getters;
